module.exports = __webpack_public_path__ + "img/wave2.b9786dfa.svg";